import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { AuthHttp } from '../core/auth-http.service';

@Injectable()
export class SharedService {

  $userType = new ReplaySubject(1);
  $spinerLoading = new ReplaySubject(1);

  constructor(private http: AuthHttp) {}

  setUserType(userType) {
    this.$userType.next(userType)
  }

  getUserTravel() {
    return this.$userType;
  }

  changeSessionData(sessionData) {
    return this.http.post('user/sessionData', sessionData)
     .map(response => response.json())
   }


   setSpinerLoading(value) {
     this.$spinerLoading.next(value);
   }

   getSpinerloading() {
     return this.$spinerLoading
   }
}



// WEBPACK FOOTER //
// ./src/app/shared/shared.service.ts